export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses/state.js